import { DealRequest } from '@/app/api/types';
import { TFunction } from 'i18next';

export type InternationalDealKind = 'export' | 'import' | null;

/**
 * Импорт - isInternational && isReverseFactoring. Если isReverseFactoring
 * не пришёл (например, в списке), смотрим на factoringSubType: у
 * международной сделки импорт приходит как reverse, экспорт - как closed.
 */
export const getInternationalDealKind = (
  data: Pick<
    DealRequest,
    'isInternational' | 'isReverseFactoring' | 'factoringSubType'
  >
): InternationalDealKind => {
  if (!data?.isInternational) return null;
  const isImport =
    typeof data.isReverseFactoring === 'boolean'
      ? data.isReverseFactoring
      : data.factoringSubType === 'reverse';
  return isImport ? 'import' : 'export';
};

/**
 * Метка международной сделки в карточках и списках. Готовую локализованную
 * метку отдаёт бэк в factoringSubTypeName, i18n-ключ - запасной вариант.
 */
export const getInternationalDealLabel = (
  data: Pick<DealRequest, 'factoringSubTypeName'>,
  kind: Exclude<InternationalDealKind, null>,
  t: TFunction<'translation', undefined>
) =>
  data.factoringSubTypeName ||
  t(
    kind === 'import'
      ? 'factoring_types.import'
      : 'settings.factoring_types.export'
  );

export const getDealBuyerName = (
  data: Pick<DealRequest, 'buyer' | 'foreignContractorName'>
): string => data.buyer?.name || data.foreignContractorName || '';

export const getDealSellerName = (
  data: Pick<DealRequest, 'seller' | 'foreignContractorName'>
): string => data.seller?.name || data.foreignContractorName || '';
